'use strict';

wbApp.factory('activityStudentSettingSvc', ['$resource', '$q', 'repositorySvc',
    function ($resource, $q, repositorySvc) {

        var ActivityStudentSetting = $resource('/Api/ActivityStudentSetting/:id', {}, {
            'getByStudentAndActivity': { method: 'GET', url: '/Api/ActivityStudentSetting/GetByStudentAndActivity' },
            'update': { method: 'POST', url: '/Api/ActivityStudentSetting/Update' },
            'insert': { method: 'POST', url: '/Api/ActivityStudentSetting/Insert' },
            'delete': { method: 'POST', url: '/Api/ActivityStudentSetting/Delete' }
        });

        function createNew() {
            return {
            };
        }

        function getByStudentAndActivity(studentID, activityID) {
            return repositorySvc.customGet('getByStudentAndActivity', ActivityStudentSetting, {
                studentID: studentID,
                activityID: activityID
            });
        }

        function saveAsync(data, origData) {
            var deferred = $q.defer();

            function success(d) {
                deferred.resolve(d);
            }

            function error(e) {
                deferred.reject(e);
            }

            if (angular.equals(data, origData)) {
                deferred.resolve(data);
            } else {
                if (data.activityStudentSettingID) {
                    update(data, success, error);
                } else {
                    insert(data, success, error);
                }
            }

            return deferred.promise;
        }

        function insert(data, successCallback, errorCallback) {
            repositorySvc.insert(
                ActivityStudentSetting,         // $resource
                null,                          // collection
                data,                          // entity
                successCallback,
                errorCallback,
                'activityStudentSettingID');
        }

        function update(data, successCallback, errorCallback) {
            repositorySvc.update(
                ActivityStudentSetting,        // $resource
                null,                         // collection
                data,                         // entity
                successCallback,
                errorCallback,
                'activityStudentSettingID');
        }

        function remove(data, successCallback, errorCallback) {
            repositorySvc.remove(
                ActivityStudentSetting,        // $resource
                null,                         // collection
                data,                         // entity
                successCallback,
                errorCallback,
                { activityStudentSettingID: data.activityStudentSettingID },
                'activityStudentSettingID');
        }

        return {
            createNew: createNew,
            getByStudentAndActivity: getByStudentAndActivity,
            insert: insert,
            update: update,
            remove: remove,
            saveAsync: saveAsync
        }
    }]);